/* unplugin-vue-components disabled */import script from "./detailsHeaderAddress.vue?vue&type=script&lang=js"
export * from "./detailsHeaderAddress.vue?vue&type=script&lang=js"

import "./detailsHeaderAddress.vue?vue&type=style&index=0&id=6ed2a0d2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed2a0d2"]])

export default __exports__